import React from "react";
import styles from "./Preloader.module.scss";
import Spinner from '../../assets/icons/40/spinner.svg'
import {PreloaderPropsInterface} from "./Preloader.props.interface";

const Preloader: React.FC<PreloaderPropsInterface> = (
    {
        ...rest
    }) => {

    return (
        <div {...rest}>
            <div className={styles.container}>
                <Spinner/>
            </div>
        </div>
    );
};

export default Preloader;
